
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M6 18c0 .5.5 1 1 1h32a2 2 0 0 1 2 2v5h-3.5a3.5 3.5 0 1 0 0 7H41v7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zM7 13a1 1 0 0 1 1-1h27a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-back",attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M4 34V13a3 3 0 0 1 3-3h30a2 2 0 0 1 2 2v9"}}),_c('path',{staticClass:"i-front",attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M39 21v-3a2 2 0 0 0-2-2H7a3 3 0 0 1-3-3v24a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2v-3m-3.5-3H40a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-4.5a3.5 3.5 0 1 0 0 7Z"}})])
          )
        }
      }
    